import { Component, OnInit } from '@angular/core';
import { AuthRepo } from 'src/app/modules/auth/repositories/auth.repo';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private authRepo: AuthRepo,
    private router: Router) { }

  ngOnInit() {
    if (this.validateSession()) {
      this.router.navigateByUrl('/home/certificates/' + this.authRepo.getUser().id);
    }
  }

  validateSession() {
    let user = this.authRepo.getUser();
    if (user === null || user === undefined) {
      this.router.navigateByUrl('/login');
    } else {
      return true;
    }
  }

}
